import { render, staticRenderFns } from "./LdpFormDongHo.vue?vue&type=template&id=d8b38a0e&scoped=true&"
import script from "./LdpFormDongHo.vue?vue&type=script&lang=js&"
export * from "./LdpFormDongHo.vue?vue&type=script&lang=js&"
import style0 from "./LdpFormDongHo.vue?vue&type=style&index=0&id=d8b38a0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b38a0e",
  null
  
)

export default component.exports